export const isClient = (): boolean => typeof window !== 'undefined';
export const isBrowser = isClient;
export const isServer = (): boolean => !isClient();
